import React from 'react';
import { compactMoney } from '../format';

export default function ValuationRangeBody({ artifact, data }) {
  const low = data.low || 0;
  const high = data.high || 0;
  const value = data.value || 0;
  const span = Math.max(high - low, 1);
  const pos = Math.max(0, Math.min(100, ((value - low) / span) * 100));
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-1">
        <span className="text-[28px] font-light tracking-[-0.02em] tabular-nums">{compactMoney(value)}</span>
        <span className="text-[14px] text-muted-foreground tabular-nums">
          Most likely value · range {compactMoney(low)} – {compactMoney(high)}
        </span>
      </div>
      {artifact.summary && <p className="m-0 text-[15px] leading-[1.6] text-foreground/[0.88]">{artifact.summary}</p>}
      <div
        role="img"
        aria-label={`Range ${compactMoney(low)} to ${compactMoney(high)}, most likely ${compactMoney(value)}`}
        className="relative h-7"
      >
        <div className="absolute top-[11px] inset-x-0 h-1.5 rounded-full bg-gradient-to-r from-succeedo-orange/25 to-succeedo-orange/60" />
        <div
          className="absolute top-[5px] w-[18px] h-[18px] -ml-[9px] rounded-full bg-background border-2 border-succeedo-orange"
          style={{ left: `${pos}%` }}
        />
      </div>
    </div>
  );
}
